import React, { useState } from 'react';
import { X } from 'lucide-react';

/**
 * Issue the next revision of a package.
 *
 * Exists because remarks need typing and window.prompt is banned outright by the UI standard —
 * notify.confirm only gets a yes/no, and the remark is the record of WHY a revision was issued,
 * so it is worth a real field.
 */
export default function DsPackageReviseModal({ pkg, busy, onClose, onConfirm }) {
  const [remarks, setRemarks] = useState('');

  return (
    <div className="stui-modal-overlay" onClick={busy ? undefined : onClose}>
      <div className="stui-modal stui-modal-md" onClick={e => e.stopPropagation()}>
        <div className="stui-modal-header">
          <span className="stui-modal-title">Issue Revision — {pkg.dsPackage}</span>
          <button className="stui-fk-select-btn" onClick={onClose} disabled={busy} title="Close"><X size={20} /></button>
        </div>

        <div className="stui-modal-body">
          <div className="stui-detail-grid">
            <div className="stui-field-group stui-col-8">
              <label>Current Revision</label>
              <div className="stui-field-readonly">{pkg.dsPackageRev}</div>
            </div>
            <div className="stui-field-group stui-col-16">
              <label>Status</label>
              <div className="stui-field-readonly">{pkg.dsStatus}</div>
            </div>
            <div className="stui-field-group stui-col-24">
              <label>What changed?</label>
              <input
                className="stui-field-input"
                value={remarks}
                onChange={e => setRemarks(e.target.value)}
                placeholder="Recorded as the revision remark"
                maxLength={1000}
                disabled={busy}
              />
            </div>
          </div>
          <p className="stui-hint">
            Re-scans the source and adds any newly matching tags as new records, flagged with the
            revision they arrived in. Anything the approver returned is re-issued with a fresh
            snapshot. Approved records are left untouched, and nothing is removed.
          </p>
        </div>

        <div className="stui-modal-footer">
          <button className="stui-btn stui-btn-secondary" onClick={onClose} disabled={busy}>Cancel</button>
          <button
            className="stui-btn stui-btn-primary"
            onClick={() => onConfirm(remarks)}
            disabled={busy || !remarks.trim()}
          >
            {busy ? 'Issuing…' : 'Issue Revision'}
          </button>
        </div>
      </div>
    </div>
  );
}
